import type { MonospaceInvite } from '#layers/data-model/public';
import { RStoreSchema } from '#imports';
import { defineSystemDateTimeFields, defineSystemDateTimeFieldTypes } from '~/rstore/utils/system-datetime-fields';

const INVITE_DATETIME_FIELDS = ['expiresAt', 'createdAt'] as const;

export const Invite = RStoreSchema.withItemType<MonospaceInvite>().defineCollection({
	name: 'MonospaceInvite',
	scopeId: 'monospace-default',
	fields: defineSystemDateTimeFields(INVITE_DATETIME_FIELDS),
	meta: {
		defaultFields: [
			'id',
			'email',
			'workspaceId',
			'workspaceRoles',
			'orgRoleId',
			'invitedById',
			'expiresAt',
			'createdAt',
		],
		endpoint: 'system/invites',
		primitiveFieldTypes: defineSystemDateTimeFieldTypes(INVITE_DATETIME_FIELDS),
	},
});
